import { $ } from "../../../helpers/dom-selectors.js";
import Overlay from "../overlay.js";
export default function makeFileError({ overlayEl }) {
    const OVERLAY = new Overlay(overlayEl);
    const titleText = $(overlayEl, '.file-error-title')[0];
    const msgText = $(overlayEl, '.file-error-msg')[0];
    const okBtn = $(overlayEl, 'button')[0];
    okBtn.addEventListener('click', () => OVERLAY.hide());
    return Object.freeze({
        show
    });
    function show(title, message) {
        titleText.innerText = title;
        msgText.innerHTML = message;
        OVERLAY.show();
    }
}
